import ENV from "config/Env";
import { backendQueryKey } from "hooks/useTypedQuery";

import type { DealerDMS } from "models";

const component = "DMSv3SettingsDashboard";

export const DMSv3SettingsDashboardQueryKeys = {
  dealers: backendQueryKey<DealerDMS[]>({ component, baseUrl: ENV.dmsv3BaseURL, endpoint: "/config/dealer/list" })
};
